import { render, staticRenderFns } from "./NumberSpinner.vue?vue&type=template&id=6cb03aea&scoped=true&"
import script from "./NumberSpinner.vue?vue&type=script&lang=ts&"
export * from "./NumberSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./NumberSpinner.vue?vue&type=style&index=0&id=6cb03aea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb03aea",
  null
  
)

export default component.exports